import React from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid'
import { process } from "@progress/kendo-data-query";


const dataState = {
    sort: [
        {
            field: "Date",
            dir: "desc",
        },
    ],
    take: 10,
    skip: 0,
};

class SurveyList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedSurvey: { },       
            dataState: dataState,
            items: {}
        }
    }
    

    getSelectedClass = (job, client) => {
        if (this.state.selectedSurvey.job && (this.state.selectedSurvey.job === job && this.state.selectedSurvey.client === client)) {
            return "select-row selected";
        } else {
            return "select-row";
        }
    };

    selectSurvey = (job, client) => {
        if (this.state.selectedSurvey.job && (this.state.selectedSurvey.job === job && this.state.selectedSurvey.client === client)) {
            //this.props.onNext();//this.setState({ selectedSurvey: { job: "", client: ""} });
        } else {
            this.setState({ selectedSurvey: { job: job, client: client} });
        }
        if (this.props.onSelect) {
            this.props.onSelect(job, client);
        }
    };
    
    hasSelectedItem = () => {
        return (this.state.selectedSurvey.job && this.state.selectedSurvey.job !== "") ? true : false;
    };

    formatSurveyDate(sd) {
        var rtn = "";
        if (sd != null) {
            var d = new Date(sd),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            rtn = year + "-" + month + "-" + day;
        }
        return rtn;
    }
  
    render() {
        this.state.items = this.props.surveys.map(c => (
            {
                Status: c.surveyState ? c.surveyState : "",
                Job: c.jobNumVendor,
                Area: c.surveyArea ? c.surveyArea : "",
                Client: c.client,
                Date: this.formatSurveyDate(c.schemaDTS),
                Description: c.projDesc ? c.projDesc : "",
                CreatedBy: c.createdBy ? c.createdBy : "",
                EditedBy: c.editedBy ? c.editedBy : "",
                selected: c.jobNumVendor === this.state.selectedSurvey.job && c.client === this.state.selectedSurvey.client
            }))
       // console.log(this.state.items)
return (
<div className="col-md-12">
{ this.props.surveys && 
<div>
    <div><label>Select a survey:</label></div>
    {/* <div class="lds-ring"><div></div><div></div><div></div><div></div></div> */}
    <div className="lds-spinner" style={{position:"absolute", top:"120px", left:"50px", display: (this.props.surveys.length === 0) ? "block" : "none"}}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div className="k-override-font-size" style={{display: (this.props.surveys.length === 0) ? "none" : "block"}}>
                <Grid style={{ height: '500px' }}                 
                        pageable={{
                       buttonCount: 0,
                       info: true
                   }}
                    sortable={true}
                    filterable={true}
        rowRender={(trElement, dataItem) => {
            const trProps = {
                ...trElement.props,
                onDoubleClick: () => {
                    if (this.props.onSelectSave) {
                        this.props.onSelectSave(dataItem.dataItem.Job, dataItem.dataItem.Client);
                    }
                }
            };
            return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
        }}
                    data={process(this.state.items, this.state.dataState)}
                    {...this.state.dataState}
                    onDataStateChange={(e) => {
                        this.setState({
                            dataState: e.dataState,
                        });
                    }}      
        
        selectedField="selected"
        onRowClick={(e) => {
            this.selectSurvey(e.dataItem.Job, e.dataItem.Client);
        }}
                >
        <Column field="Status" title="Status" width="100px" />
                    <Column field="Job" title="Job Number" width="150px" />
                    <Column field="Area" title="Area" width="120px" />
        <Column field="Client" title="Client" width="150px" />                    
                    <Column field="Description" title="Project Description" />
                    <Column field="Date" title="Date" width="130px" />
                    <Column field="CreatedBy" title="Created By" width="120px" />
                    <Column field="EditedBy" title="Edited By" width="120px" />
    </Grid>
    </div>
</div>
}
<div style={{ fontWeight: "bold" }}><span style={{display: this.hasSelectedItem() ? "inline" : "none"}}>Click to open the selected survey</span><span>&nbsp;</span></div>
</div>
)}
}

export default SurveyList;